export enum pageRulesRedirectOptionType {
  No_Redirection = '0',
  HTTP_TO_HTTPS = '1',
  HTTPS_TO_HTTP = '2',
}
